import { UtilitiesInstance, ShopInstance } from '@/store'
import { catchError } from '@/utils/catchError'
import { BRAND_ENUM } from '../../enums/brands.enum'
const payment = {
  state: {
    selectedPaymentMethod: '',
    selectedPaymentType: '',
    billing_address: {
      city: '',
      country: '',
      neighborhood: '',
      number: '',
      state: '',
      street: '',
      complement: '',
      zip_code: '',
      use_client_address: false,
      show_address: true
    },
    boleto: {
      due_at: '',
      instructions: ''
    },
    card: {
      number: '',
      holder_name: '',
      exp_month: null,
      exp_year: null,
      cvv: '',
      label: '',
      operation: ''
    },
    credit_card: {
      installments: 1,
      card_token: '',
      capture: false,
      operation_type: '',
      statement_descriptor: ''
    },
    creditCardBrand: {
      cvv: 3
    },
    checkout: {
      shippable: true,
      accepted_payment_methods: [],
      expires_in: '',
      credit_card: {
        installments: 1,
        capture: false,
        operation_type: '',
        statement_descriptor: ''
      },
      boleto: {
        due_at: ''
      },
      pix: {
        expires_at: ''
      }
    },
    pix: {
      expires_at: '',
      qr_code_url: '',
      qr_code: ''
    }
  },
  getters: {
    paymentMethodItems () {
      return [
        {
          title: 'checkout',
          icon: 'uil-external-link-alt'
        },
        {
          title: 'boleto',
          icon: 'uil-invoice'
        },
        {
          title: 'credit_card',
          icon: 'uil-credit-card'
        },
        {
          title: 'pix',
          icon: 'uil-qrcode-scan'
        }
      ]
    },
    paymentTypeItems (_state, getters) {
      return getters.hasSubscriptionEnabled ? [
        {
          title: 'items',
          icon: 'uil-shopping-basket'
        },
        {
          title: 'subscription',
          icon: 'uil-redo'
        }
      ]
        : [
          {
            title: 'items',
            icon: 'uil-shopping-basket'
          }
        ]
    },
    paymentTypeV2Items () {
      return [
        {
          title: 'products-services',
          icon: 'uil-link-alt'
        },
        {
          title: 'typed-sale',
          icon: 'uil-credit-card'
        }
      ]
    },
    checkoutExpirationOptions () {
      return [
        {
          value: 60,
          label: '1 hora',
          id: '1hora'
        },
        {
          value: 12 * 60,
          label: '12 horas',
          id: '12hora'
        },
        {
          value: 24 * 60,
          label: '1 dia',
          id: '1dia'
        },
        {
          value: 7 * 24 * 60,
          label: '1 semana',
          id: '1semana'
        },
        {
          value: 15 * 24 * 60,
          label: '15 dias',
          id: '15dias'
        },
        {
          value: 30 * 24 * 60,
          label: '1 mês',
          id: '1mes'
        }
      ]
    },
    billing_address (state) {
      return state.billing_address
    },
    brands () {
      return Object.values(BRAND_ENUM)
    },
    selectedPaymentType (state) {
      return state.selectedPaymentType
    },
    selectedPaymentMethod (state) {
      return state.selectedPaymentMethod
    },
    boleto (state) {
      return state.boleto
    },
    card (state) {
      return state.card
    },
    credit_card (state) {
      return state.credit_card
    },
    creditCardBrand (state) {
      return state.creditCardBrand
    },
    checkout (state) {
      return state.checkout
    },
    pix (state) {
      return state.pix
    }
  },
  mutations: {
    SET_PAYMENT_METHOD (state, value) {
      state.selectedPaymentMethod = value
    },
    SET_PAYMENT_TYPE (state, value) {
      state.selectedPaymentType = value
    },
    RESET_PAYMENT_STATE (state, value) {
      if (value) {
        state.selectedPaymentMethod = ''
      }
      state.boleto = {
        due_at: '',
        instructions: ''
      }
      state.card = {
        number: '',
        holder_name: '',
        exp_month: null,
        exp_year: null,
        cvv: '',
        label: '',
        operation: 'auth_and_capture'
      }
      state.credit_card = {
        installments: 1,
        card_token: '',
        capture: true,
        operation_type: '',
        statement_descriptor: ''
      }
      state.creditCardBrand = {
        link: ''
      }
      state.checkout = {
        shippable: true,
        accepted_payment_methods: [],
        expires_in: '',
        credit_card: {
          installments: 1,
          capture: true,
          operation_type: 'auth_and_capture',
          statement_descriptor: ''
        },
        boleto: {
          due_at: ''
        },
        pix: {
          expires_at: ''
        }
      }
      state.checkout_due_date = {
        date: ''
      }
      state.pix = {
        expires_at: '',
        qr_code_url: '',
        qr_code: ''
      }
    },
    SET_BILLING_ADDRESS (state, res) {
      state.billing_address = res
    },
    RESET_BILLING_ADDRESS_FLAGS (state, value) {
      state.billing_address.use_client_address = !value
      state.billing_address.show_address = value
    }
  },
  actions: {
    GET_BRAND (context, value) {
      return UtilitiesInstance.commons
        .getBrandByBin(value)
        .then((res) => Promise.resolve(res.data.brands[0]))
        .catch((err) => catchError(err, context))
    },
    SET_PAYMENT_METHOD (context, value) {
      context.commit('SET_PAYMENT_METHOD', value)
    },
    SET_PAYMENT_TYPE (context, value) {
      context.commit('SET_PAYMENT_TYPE', value)
    },
    SET_BILLING_ADDRESS (context, value) {
      context.commit('SET_BILLING_ADDRESS', value)
    },
    CREATE_CARD_TOKEN (context, body) {
      return ShopInstance.order
        .createCardToken(body.public_key, body.card)
        .then((res) => Promise.resolve(res))
        .catch((err) => catchError(err, context))
    },
    RESET_PAYMENT_STATE (context, value = true) {
      context.commit('RESET_PAYMENT_STATE', value)
    },
    RESET_BILLING_ADDRESS_FLAGS (context, value = true) {
      context.commit('RESET_BILLING_ADDRESS_FLAGS', value)
    }
  }
}

export default payment
